import type { MenubarDesignTokens, MenubarTokenSections } from '@openng/optimus-ui-themes/types/menubar';

export const root: MenubarTokenSections.Root = {
	background: '{primary.500}',
	borderColor: '{primary.500}',
	borderRadius: '{border.radius.none}',
	color: '{primary.500}',
	gap: '0rem',
	padding: '0rem',
};

export const item: MenubarTokenSections.Item = {
	focusBackground: '{primary.400}',
	focusColor: '{neutral.white}',
	activeBackground: '{primary.400}',
	activeColor: '{neutral.white}',
	color: '{primary.100}',
};

export const submenu: MenubarTokenSections.Submenu = {
	background: '{primary.500}',
	borderColor: '{primary.500}',
};

export const mobileButton: MenubarTokenSections.MobileButton = {
	borderRadius: '{navigation.item.border.radius}',
	color: '{primary.100}',
};

export default {
	root,
	item,
	submenu,
	mobileButton,
} satisfies MenubarDesignTokens;
